import { jsx as _jsx } from "react/jsx-runtime";
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { WeeklyRecapTab } from '../tabs/WeeklyRecapTab';
export function WeeklyRecapPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsx(WeeklyRecapTab, {
            programId: programId
        })
    });
}
